module.exports = __webpack_public_path__ + "img/048-folder.a6183997.svg";